<template>
    <div>
        <section class="section section-lg section-shaped overflow-hidden my-0">
            <div class="shape shape-style-1 shape-green shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container py-0 pb-lg">
                <div class="row justify-content-between align-items-center">
                    <div class="col-lg-5 mb-5 mb-lg-0">
                        <h1 class="text-white">Occam's Apartment</h1>
                        <p class="lead text-white mt-4">{{intro}}</p>
                        <base-button tag="a"
                                     v-on:click="tracker('Booking', 'Redirected to Resova', 'Apartment page info - top')"
                                     href="https://offthecouch.io/book/otc" type="white" class="mt-4">
                            Book now
                        </base-button>
                    </div>
                    <div class="col-lg-6 mt-5 mb-lg-auto">
                        <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                            <b-carousel id="carousel1"
                                        controls
                                        indicators>
                                <!-- Text slides with image -->
                                <b-carousel-slide img-src="img/brand/asheville/apartment/Apartment1.jpg"></b-carousel-slide>
                                <b-carousel-slide img-src="img/brand/asheville/apartment/Apartment2-2.jpg"></b-carousel-slide>
                                <b-carousel-slide img-src="img/brand/asheville/apartment/Apartment3.jpg"></b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section id="games" class="section section-lg pt-lg-0 mt--150">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-12">
                                <div class="card white shadow border-0">
                                    <img v-lazy="'img/brand/asheville/apartment/Apartment4.jpg'" class="card-img-top fixed-height">
                                </div>
                                <card class="border-0" shadow>
                                    <div class="row ml-2">
                                        <div class="mb-4 d-flex align-right">
                                            <icon name="ni ni-single-02" class="bg-gradient-white" color="success" shadow rounded></icon>
                                            <span class="mt-3 ml-3 mr-5 text-success text-uppercase font-weight-bold">{{players}}</span>
                                        </div>
<!--                                        <div class="mb-4 d-flex align-right">-->
<!--                                            <icon name="ni ni-trophy" class="bg-gradient-white" color="success" shadow rounded></icon>-->
<!--                                            <span class="mt-3 mr-4 ml-3 text-success text-uppercase font-weight-bold">{{difficulty}}</span>-->

<!--                                        </div>-->
                                        <div class="mb-4 d-flex align-right">
                                            <icon name="ni ni-time-alarm" class="bg-gradient-white" color="success" shadow rounded></icon>
                                            <span class="mt-3 ml-3 text-success text-uppercase font-weight-bold">{{duration}}</span>
                                        </div>
                                    </div>
                                    <h4 class="mt-2 text-success">Chapter 1: Occam's Apartment</h4>
                                    <p class="mt-2">{{description}}</p>
                                  <p class="mt-2">
                                    Addressed to his closest friends, a single message was left behind: <span class="text-color">“There are two sides to every man, the one that you see and the one hidden behind the scenes. I can only be the real me when I go fishing on the lake. Memories I will never forget.”</span>
                                  </p>
                                    <p class="mt-3">
                                        <span class=" text-success text-uppercase font-weight-bold">{{disclaimer}}</span>
                                        {{disclaimer2}}
                                    </p>
                                  <p class="mt-3">
                                    <span class=" text-success text-uppercase font-weight-bold">{{disclaimer4}}</span>
                                    {{disclaimer5}}
                                  </p>
                                  <p>
                                    <strong>{{disclaimer3}}</strong>
                                  </p>

                                    <base-button tag="a"
                                                 v-on:click="tracker('Booking', 'Redirected to Resova', 'Apartment page info - bottom')"
                                                 href="https://offthecouch.io/book/otc" type="white" class="mt-2 mb-2">
                                        Book now
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
    import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
    export default {
        name: "Apartment",
        components: {BCarousel, BCarouselSlide},
        data () {
            return {
                description: "Your dear friend Detective William Occam recently passed away while investigating a case about a 10-year-old missing girl, Nina. Following his death, you received a mysterious letter. \n",
                disclaimer: "ALL BOOKINGS ARE PRIVATE. ",
                disclaimer2: "Only your group will be in the game.",
                disclaimer3: "This is the first of twelve chapters, with each chapter ranging in length from 90-180 minutes. It is recommended that players start here before proceeding into Asheville: Norcross Art Gallery. If you would like to book more than 105 minutes, please contact us. Note that if you do not complete the chapter within 105 minutes, your progress is saved and you will resume where you left off when you return. Any remaining time at the end of the chapter is credited back to your account to be used for future bookings.",
                disclaimer4: "GAME IS NOT SUITABLE FOR CHILDREN, ",
                disclaimer5: "please contact us if you have any questions.",
                players: "2-6",
                difficulty: "Medium - Hard",
                duration: "105 minutes",
                intro: "                                      Your friend Detective William Occam recently died. Following his death, you received a mysterious letter that reinforces your belief that something was odd about his death. You decide to investigate on your own what really happened to William.\n"
            }
        },
        methods: {
            tracker(category, action, label) {
                this.$ga.event(category, action, label)
            }
        }
    }
</script>

<style scoped>
.fixed-height{
  width: 100%; /* width of container */
  height: 300px; /* height of container */
  object-fit: cover;
}
.text-color{
  color: #016455;
  font-weight: bold;
}
</style>
